import {
  Box,
  Chip,
  Collapse,
  IconButton,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import React from "react";
import IActivityLogEntry from "../interface/iActivityLogEntry";
import {
  getActionLabel,
  getActorLabel,
  getAreaLabel,
  getRoleLabel,
  getStatusLabel,
} from "../functions/activityLogLabels";
import ActivityLogDetails from "./activityLogDetails";
import formatAppointment from "../functions/formatAppointment";

const COLUMN_COUNT = 8;

const formatTimestamp = (date: string): string => {
  const [day, time] = date.split(" ");
  const [year, month, dayOfMonth] = day.split("-");
  return `${dayOfMonth}.${month}.${year}, ${time.slice(0, 5)}`;
};

const ActivityLogRow = ({
  entry,
}: {
  entry: IActivityLogEntry;
}): React.JSX.Element => {
  const [open, setOpen] = React.useState<boolean>(false);
  const detailsId = `activity-log-details-${entry.id}`;
  const appointment = formatAppointment(entry);

  return (
    <>
      <TableRow hover sx={{ "& > td": { borderBottom: open ? "none" : undefined } }}>
        <TableCell padding="checkbox">
          <IconButton
            size="small"
            aria-label={open ? "Details ausblenden" : "Details anzeigen"}
            aria-expanded={open}
            aria-controls={detailsId}
            onClick={() => setOpen((prev) => !prev)}
          >
            {open ? <ExpandLessOutlinedIcon /> : <ExpandMoreOutlinedIcon />}
          </IconButton>
        </TableCell>
        <TableCell sx={{ whiteSpace: "nowrap" }}>{formatTimestamp(entry.date)}</TableCell>
        <TableCell>
          <Typography variant="body2">{getActorLabel(entry)}</Typography>
          {entry.actor?.email && (
            <Typography variant="caption" color="text.secondary">
              {entry.actor.email}
            </Typography>
          )}
        </TableCell>
        <TableCell>
          <Chip size="small" variant="outlined" label={getRoleLabel(entry.actorRole)} />
        </TableCell>
        <TableCell>{getAreaLabel(entry.area)}</TableCell>
        <TableCell sx={{ minWidth: 220 }}>
          <Typography variant="body2">{getActionLabel(entry.action)}</Typography>
          {appointment && (
            <Typography variant="caption" color="text.secondary">
              {appointment}
            </Typography>
          )}
        </TableCell>
        <TableCell>{entry.subject?.name ?? "–"}</TableCell>
        <TableCell>
          <Chip
            size="small"
            color={entry.status === "success" ? "success" : "error"}
            label={getStatusLabel(entry.status)}
          />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={COLUMN_COUNT} sx={{ py: 0 }} id={detailsId}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ py: 1.5, pl: 6 }}>
              <ActivityLogDetails entry={entry} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default ActivityLogRow;
